import React from "react";



function Design() {
    return (
        <div className="design">
            <div className="section-1">
                <img src="./images/1.jpg"/>
            </div>
            <div className="section-2">
                <img src="./images/2.jpg"/>
                <img src="./images/3.jpg"/>
            </div>
            <div className="section-3">
                <img src="./images/4.jpg"/>
                <img src="./images/5.jpg"/>
                <img src="./images/6.jpg"/>
            </div>
            <div className="section-4">
                <img src="./images/9.jpg"/>
                <img src="./images/11.jpg"/>
            </div>
            <div className="section-5">
                <img src="./images/7.jpg"/>
            </div>
        </div>
    );
}


export default Design